import * as React from "react";

export const IconLogin = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.5 3.33333L6.33333 4.5L8.5 6.66667L0 6.66667L0 8.33333L8.5 8.33333L6.33333 10.5L7.5 11.6667L11.6667 7.5L7.5 3.33333ZM15 13.3333H8.33333V15H15C15.9167 15 16.6667 14.25 16.6667 13.3333L16.6667 1.66667C16.6667 0.75 15.9167 0 15 0L8.33333 0V1.66667L15 1.66667L15 13.3333Z"
      fill={props?.color || "#48A0B2"}
    />
  </svg>
);
